import React from 'react';
import Typography from '@material-ui/core/Typography';

import {getLocale} from '@epic-core/common/dist';

import DataUnavailableBox from './DataUnavailableBox';
import {numberFormatter} from '../../utils/FNUtils';

export interface StatisticsCardContentProps {
    title: string;
    value?: number | string;
    previousValue?: number | string;
    tooltip?: JSX.Element | string;
}

const StatisticsCardContent = ({
    title,
    value,
    tooltip,
    previousValue
}: StatisticsCardContentProps) => {
    const formatNumber = numberFormatter(getLocale());

    return value ? (
        <Typography variant="h3" style={{fontWeight: 'normal'}} noWrap={true}>
            {typeof value === 'number' ? formatNumber(value) : value}
        </Typography>
    ) : (
        <DataUnavailableBox
            title={title}
            previousValue={
                previousValue && typeof previousValue === 'number'
                    ? formatNumber(previousValue)
                    : previousValue
            }
            tooltip={tooltip}
        />
    );
};

export default StatisticsCardContent;
